import { Box, Typography, useTheme, Fade } from "@mui/material";

const LoadingBrand = () => {
  const theme = useTheme();

  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: theme.palette.background.default,
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={require("./loading.gif")}
            alt="Loading..."
            sx={{
              height: 250,
              width: 250,
              objectFit: "contain",
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 400,
              color: "#6b7280",
              textAlign: "center",
            }}
          >
            Preparing your experience...
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};

export default LoadingBrand;
